import { queryOptions, useQuery } from '@tanstack/react-query'
import { UserQueries } from '@/queries/users/queries.ts'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/storage/store.ts'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider.tsx'
import { CustomQueryOptions, NoContent } from '@/common/types_and_interfaces.ts'
import axiosInstance from '@/libs/axios_config.ts'
import { parseRequestError } from '@/common/utilities.ts'
import { RefreshFamilyApplication } from '@/storage/applications/familyApplicationSlice.ts'

export async function syncTransferScholars(
  programId: number
): Promise<NoContent> {
  try {
    await axiosInstance.get(`/transfer_applicants/status`, {
      params: { program_id: programId },
    })
    return ''
  } catch (e) {
    throw new Error(parseRequestError(e).message)
  }
}

const TransferApplicantQueryKeys = {
  transferScholars: ['transferScholars'] as const,
}

function getTransferApplicantStatus(
  programId: number,
  options: CustomQueryOptions<NoContent>,
  onSuccess?: () => void
) {
  return queryOptions({
    queryKey: TransferApplicantQueryKeys.transferScholars,
    queryFn: async () => {
      const response = await syncTransferScholars(programId)
      if (onSuccess) {
        onSuccess()
      }
      return response
    },
    ...options,
  })
}

export const useSyncTransferStudents = () => {
  const { selectedProgramId } = useApplicantProgramYears()
  const application = useSelector((state: RootState) => state.FamilyApplication)
  const SessionUserQuery = useQuery(
    UserQueries.getAuthenticatedUser(application.data?.applicant_id ?? -1)
  )
  const dispatch = useDispatch<AppDispatch>()

  useQuery(
    getTransferApplicantStatus(
      selectedProgramId,
      {
        staleTime: Infinity,
        // staleTime only covers successful data; without this, a failed
        // sync refetches every time RefreshApplication remounts.
        retryOnMount: false,
        enabled: !!SessionUserQuery.data?.external_id && selectedProgramId !== 0,
      },
      () => {
        dispatch(RefreshFamilyApplication(selectedProgramId))
        return
      }
    )
  )
}
